/**
 * SHA-256 of a file's contents, hex encoded — the same digest the API computes
 * server-side, so the two can be compared for duplicate detection.
 */
export async function sha256File(file: File): Promise<string> {
  const buffer = await file.arrayBuffer()
  const digest = await crypto.subtle.digest('SHA-256', buffer)

  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * `crypto.subtle` only exists in a secure context. When it is missing we skip
 * the pre-flight check entirely and let the server's 409 catch duplicates.
 */
export function canHashLocally(): boolean {
  return typeof crypto !== 'undefined' && typeof crypto.subtle?.digest === 'function'
}
